
import Menu from './Menu'
import { RootState } from '../../store/store';
import { useSelector } from 'react-redux';
import BalanceBadges from '../BalanceBadges';
import { useCallback, useState } from 'react';
import DrawerViewBalancesByContract from '../../pages/contract/viewBalances/DrawerViewBalancesByContract';
import { hasRoleAccess } from '../../utils/roles';

const HeaderContract = ({ isFetching, roles }: any) => {

    const { service_id, contract_id, total } = useSelector((state: RootState) => state.contract)

    const [isOpenBalancesDrawer, setIsOpenBalancesDrawer] = useState(false);
    const [balanceKey, setBalanceKey] = useState<number>(1);

    const handleOpenBalances = (key: string) => {
        setIsOpenBalancesDrawer(true)
        setBalanceKey(Number((key.replace('balance_', ''))))
    }

    const handleCloseBalances = () => {
        setIsOpenBalancesDrawer(false)
        setBalanceKey(0)
    }

    const isDisabledBalances = useCallback(
        () => {
            if (roles && hasRoleAccess('payments.view', roles)) return false
            return true
        },
        [roles],
    )

    return (
        contract_id ?
            <div className='hidden lap:flex justify-between items-end gap-[16px] border-t border-gray-100'>
                <DrawerViewBalancesByContract
                    open={isOpenBalancesDrawer}
                    handleClose={handleCloseBalances}
                    balanceKey={balanceKey}
                />
                <Menu roles={roles} />
                {
                    <BalanceBadges
                        isHeader
                        isFetching={isFetching}
                        service_id={service_id}
                        items={total ? total : {}}
                        className={` !bg-gray-100 
                            ${service_id === 1 ? '!px-[6px] lap:!px-[12px] des:!px-[16px] !py-[10px]'
                                :
                                service_id === 2 ? '!px-[6px] lap:!px-[8px] lap2:!px-[4px] des:!px-[8px] flex-col !items-center lap2:!items-baseline lap2:flex-row !py-[8px] lap2:!py-[10px]'
                                    : ''
                            }`}
                        contClassName='my-[12px] Fflex flex-wrap justify-end !gap-[4px] lap2:!gap-[8px]'
                        handleOpenBalancesDrawer={isDisabledBalances() ? null : handleOpenBalances}
                    />
                }
            </div>
            :
            <></>

    )
}

export default HeaderContract